import {
  Button,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
} from '@nextui-org/react';

import React from 'react';
import { PartnerInfo } from '../../types';
import moment from 'moment';

interface PartnerTableProps {
  partners: PartnerInfo[];
  onEdit: (partner: PartnerInfo) => void;
  onDelete: (partner: PartnerInfo) => void;
}

const PartnerTable: React.FC<PartnerTableProps> = ({
  partners,
  onEdit,
  onDelete,
}) => {
  return (
    <Table
      isCompact
      aria-label="Partner Management Table"
      classNames={{
        th: 'bg-slate-50 text-slate-500 text-xs font-semibold uppercase tracking-wider',
        td: 'text-sm text-slate-700 py-3',
      }}
    >
      <TableHeader>
        <TableColumn>Company</TableColumn>
        <TableColumn>Contact</TableColumn>
        <TableColumn>Email</TableColumn>
        <TableColumn>Shopify ID</TableColumn>
        <TableColumn>Joined</TableColumn>
        <TableColumn>Status</TableColumn>
        <TableColumn width={140}>Actions</TableColumn>
      </TableHeader>
      <TableBody emptyContent="No partners found.">
        {partners.map(partner => (
          <TableRow key={(partner as any)._id || partner.id}>
            <TableCell>
              <span className="font-medium text-slate-800">
                {partner.company_name}
              </span>
            </TableCell>
            <TableCell>
              {partner.first_name} {partner.last_name}
            </TableCell>
            <TableCell>
              <span className="text-xs font-mono text-slate-500">
                {partner.email}
              </span>
            </TableCell>
            <TableCell>
              <span className="text-xs font-mono text-slate-400">
                {partner.shopify_customer_id || 'N/A'}
              </span>
            </TableCell>
            <TableCell>
              <span className="text-xs text-slate-500">
                {partner.createdAt
                  ? moment(partner.createdAt).format('MMM D, YYYY')
                  : (partner as any)._creationTime
                    ? moment((partner as any)._creationTime).format('MMM D, YYYY')
                    : 'N/A'}
              </span>
            </TableCell>
            <TableCell>
              <Chip
                size="sm"
                variant="flat"
                color="success"
                className="text-xs"
              >
                Active
              </Chip>
            </TableCell>
            <TableCell>
              <div className="flex gap-1">
                <Button
                  size="sm"
                  variant="light"
                  className="text-slate-600 min-w-0 px-2"
                  onClick={() => onEdit(partner)}
                >
                  Edit
                </Button>
                <Button
                  size="sm"
                  variant="light"
                  className="text-red-500 min-w-0 px-2"
                  onClick={() => onDelete(partner)}
                >
                  Remove
                </Button>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default PartnerTable;
